import { FullLocaleData } from '../locale.types';

export default {
  abbr: 'ko-KR',
  exception: {
    403: `죄송합니다.이 페이지에 액세스 할 수 없습니다.`,
    404: `죄송합니다. 해당 페이지가 없습니다.`,
    500: `죄송합니다, 서버 오류가 있습니다.`,
    backToHome: '홈으로 돌아갑니다.',
  },
  noticeIcon: {
    emptyText: '데이터 없음',
    clearText: '지우기',
  },
  reuseTab: {
    close: '탭 닫기',
    closeOther: '다른 탭 닫기',
    closeRight: '오른쪽 탭 닫기',
    refresh: '새롭게 하다',
  },
  tagSelect: {
    expand: '펼치기',
    collapse: '접기',
  },
  miniProgress: {
    target: '대상: ',
  },
  st: {
    total: '전체 {{total}}건',
    filterConfirm: '확인',
    filterReset: '초기화',
  },
  sf: {
    submit: '제출',
    reset: '재설정',
    search: '검색',
    edit: '저장',
    addText: '추가',
    removeText: '제거',
    checkAllText: '모두 확인',
    error: {
      'false schema': `Boolean schema is false`,
      $ref: `Can't resolve reference {ref}`,
      additionalItems: `Should not have more than {limit} item`,
      additionalProperties: `Should not have additional properties`,
      anyOf: `Should match some schema in "anyOf"`,
      dependencies: `should have property {deps} when property {property} is present`,
      enum: `Should be equal to one of predefined values`,
      format: `Should match format "{format}"`,
      type: `Should be {type}`,
      required: `Required`,
      maxLength: `Should not be longer than {limit} character`,
      minLength: `Should not be shorter than {limit} character`,
      minimum: `Should be {comparison} {limit}`,
      formatMinimum: `Should be {comparison} {limit}`,
      maximum: `Should be {comparison} {limit}`,
      formatMaximum: `Should be {comparison} {limit}`,
      maxItems: `Should not have more than {limit} item`,
      minItems: `Should not have less than {limit} item`,
      maxProperties: `Should not have more than {limit} property`,
      minProperties: `Should not have less than {limit} property`,
      multipleOf: `Should be a multiple of {multipleOf}`,
      not: `Should not be valid according to schema in "not"`,
      oneOf: `Should match exactly one schema in "oneOf"`,
      pattern: `Should match pattern "{pattern}"`,
      uniqueItems: `Should not have duplicate items (items ## {j} and {i} are identical)`,
      custom: `Should match format`,
      propertyNames: `Property name "{propertyName}" is invalid`,
      patternRequired: `Should have property matching pattern "{missingPattern}"`,
      switch: `Should pass "switch" keyword validation, case {caseIndex} fails`,
      const: `Should be equal to constant`,
      contains: `Should contain a valid item`,
      formatExclusiveMaximum: `formatExclusiveMaximum should be boolean`,
      formatExclusiveMinimum: `formatExclusiveMinimum should be boolean`,
      if: `Should match "{failingKeyword}" schema`,
    },
  },
  onboarding: {
    skip: `건너 뛰기`,
    prev: `이전`,
    next: `다음`,
    done: `끝난`,
  },
} as FullLocaleData;
